/**
 *
 * Asynchronously loads the component for ShapeGuides
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ShapeGuides = lazyLoad(
  () => import('./index'),
  module => module.ShapeGuides,
);
